import { Component, Input} from '@angular/core'
@Component({
  selector: 'risk-disclaimer',
  templateUrl: './risk-disclaimer.component.html',
  styleUrls: ['./risk-disclaimer.component.scss'],
})
export class RiskDisclaimerComponent{
  @Input() riskCode: number
  @Input() levelDesc: string
  
}
